import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { LeaseInvoiceSettings, LeaseInvoiceSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';

const baseUrl = `${envConfig.service.settings}/company-portal/settings/leaseinvoice`;
export class LeaseInvoiceSettingRepository extends BaseRestRepository {
  public async getAllLeaseInvoiceSettings(): Promise<LeaseInvoiceSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = baseUrl + '/with-overrides';
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getLeaseInvoiceSettingsByLevel(level: string, levelId: string): Promise<LeaseInvoiceSettings> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateLeaseInvoiceSettings(payload: LeaseInvoiceSettings): Promise<LeaseInvoiceSettings> {
    const url = `${baseUrl}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
      }),
    });
    return this.getJsonResponse(response);
  }

  public async updateLeaseInvoiceSettingsByLevel(
    level: string,
    levelId: string,
    payload: LeaseInvoiceSettings
  ): Promise<LeaseInvoiceSettings> {
    const url = baseUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteLeaseInvoiceSettingsByLevel(level: string, levelId: string): Promise<void> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }
}
